/*
 * Potencium PL — localise the Releasit order-summary tax note (2026-11-03).
 * Built from the LT build (vx-rsi-tax-note-lt.js, 2 decimals) and the HU one (vx-rsi-tax-note-hr.js).
 * Releasit prints the amount with a dot and no currency, in its own words: English
 * "Including 12.73 in taxes", HU "Tartalmaz 3529.13 adót", LT "Įskaičiuota 12.73 mokesčių".
 * The PL Releasit settings name the tax «PVM» (taxName, a Lithuanian word), and what the Polish
 * form prints was not seen in a browser — so besides those wordings any note is accepted: the
 * amount is the LAST number in it with two decimals («57.59», «1.029,95»), otherwise the first
 * number that is not a percentage (the 23 % rate). Check the real Polish note on a preview.
 * Rewritten as «W tym VAT: 12,73 zł» (Intl pl-PL / PLN, 2 decimals). Text only — the node is
 * re-rendered by Releasit whenever the total changes, so it polls.
 * layout/theme.liquid loads this file in place of vx-rsi-tax-note-hr.js.
 */
setInterval(function () {
  document.querySelectorAll('.rsi-total-summary-taxes-note').forEach(function (el) {
    var text = (el.textContent || '').trim();
    if (!text || text.indexOf('W tym VAT:') === 0) return;
    var m = text.match(/Including\s+(.+?)\s+in\s+taxes/i) || text.match(/Tartalmaz\s+(.+?)\s+adót/i) ||
      text.match(/Įskaičiuota\s+(.+?)\s+mokesčių/i);
    var raw = m ? m[1] : null;
    if (!raw) {
      // any other wording («PVM», a Polish text, …): the last amount with two decimals, so a rate
      // printed without «%» («PVM 23: 57.59») is never taken for the amount …
      var amts = text.match(/\d+(?:[.,\u00a0\u202f]\d{3})*[.,]\d{2}(?!\d)/g) || [];
      if (amts.length) raw = amts[amts.length - 1];
    }
    if (!raw) {
      // … otherwise the first number that is not a percentage
      var nums = text.match(/\d[\d.,  ]*(?:\s*%)?/g) || [];
      for (var i = 0; i < nums.length; i++) { if (nums[i].indexOf('%') === -1) { raw = nums[i]; break; } }
    }
    if (!raw) return;
    var d = raw.replace(/[^\d.,-]/g, '');
    if (/^\d{1,3}(\.\d{3})+$/.test(d)) d = d.replace(/\./g, '');
    d = /,\d{1,2}$/.test(d) ? d.replace(/\./g, '').replace(',', '.') : d.replace(/,/g, '');
    var n = parseFloat(d);
    el.textContent = isNaN(n) ? 'W tym VAT: ' + raw + ' zł'
      : 'W tym VAT: ' + new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
  });
}, 500);
